const translations = {
    applications: 'Applications',
    claimAircraftConfirmation:
        'Claiming the aircraft will no longer allow the aircraft to be transferred to a new owner?',
    claimButton: 'Claim',
    claimOwnership: 'Claim Ownership',
    disable: 'Disable',
    disableAircraftConfirmation: 'Are you sure you want to disable the aircraft?',
    disableAircraftSubtext: 'The aircraft will require a network connection',
    editDrone: 'Edit Drone',
    enable: 'Enable',
    enableAircraftConfirmation: 'Are you sure you want to enable the aircraft?',
    enableAircraftSubtext: 'The aircraft will require a network connection',
    linkedEntities: 'Linked Entities',
    releaseAircraftConfirmation: 'Are you sure you want to release the aircraft?',
    releaseAircraftSubtext:
        'A released aircraft can be transferred to a new owner. After the aircraft is claimed by a new owner you will no longer be able to operate the aircraft',
    releaseButton: 'Release',
    releaseOwnership: 'Release Ownership'
};

export default translations;
